import React, { Suspense } from 'react';
import { useLocation } from 'react-router-dom';
import { IPageRoute, ISplitUrlLocation } from 'interfaces/routesInt';

import urls from '../urls';
import { usePage } from 'hooks/PlatformContext';

import GenerateRoutes from 'routes/generateRoute/GenerateRoutes';
import LoadingComponent from 'components/shared/Loading';

const formatUrl = (url: string) => url.slice(1);

const ManageRoutes: React.FC = () => {
  const { pathname } = useLocation();

  const splitLocation: ISplitUrlLocation = {
    segments: pathname.split('/'),
  };

  const LoginPage = usePage('LoginPage');
  const RegisterPage = usePage('RegisterPage');
  const DashboardPage = usePage('DashboardPage');
  const SalesPage = usePage('SalesPage');
  const InventoryPage = usePage('InventoryPage');
  const ProductsPage = usePage('ProductsPage');
  const FundsPage = usePage('FundsPage');
  const ArchivedStockPage = usePage('ArchivedStockPage');
  const SettingPage = usePage('SettingPage');
  const ClientPage = usePage('ClientPage');
  const ProductCategoryPage = usePage('ProductCategoryPage');
  const DebtPage = usePage('DebtPage');
  const ForgotPasswordPage = usePage('ForgotPasswordPage');
  const PageNotFound = usePage('PageNotFound');
  const SuppliersPage = usePage('SuppliersPage');
  const ManageBranchs = usePage('ManageBranchsPage');
  const StockPage = usePage('StockPage');

  const pages: IPageRoute = {
    [formatUrl(urls.landingPage)]: LoginPage,
    [formatUrl(urls.login)]: LoginPage,
    [formatUrl(urls.register)]: RegisterPage,
    [formatUrl(urls.dashboard)]: DashboardPage,
    [formatUrl(urls.sales)]: SalesPage,
    [formatUrl(urls.inventory)]: InventoryPage,
    [formatUrl(urls.products)]: ProductsPage,
    [formatUrl(urls.funds)]: FundsPage,
    [formatUrl(urls.archivedStock)]: ArchivedStockPage,
    [formatUrl(urls.settings)]: SettingPage,
    [formatUrl(urls.customers)]: ClientPage,
    [formatUrl(urls.productCategory)]: ProductCategoryPage,
    [formatUrl(urls.debts)]: DebtPage,
    [formatUrl(urls.resetPassword)]: ForgotPasswordPage,
    [formatUrl(urls.pageNotFound)]: PageNotFound,
    [formatUrl(urls.suppliers)]: SuppliersPage,
    [formatUrl(urls.manageBranchs)]: ManageBranchs,
    [formatUrl(urls.stock)]: StockPage,
  };

  return (
    <Suspense fallback={<LoadingComponent />}>
      <GenerateRoutes splitLocation={splitLocation} pageRoute={pages} />
    </Suspense>
  );
};

export default ManageRoutes;
